import {useEffect, useState} from 'react'
import {useDeviceDetect, useUrlParams} from 'services/hooks'
import {getItemId, getTableData} from 'services/utils/tables'
// import {INITIAL_PAGE_SIZE} from 'constants/tables'
import {requestsMock} from 'mockdata'

const useTable = (
    itemName,
    useGetQuery,
    paginationType,
    useDeleteMutation,
    visibleKeys,
    allowExpand,
    queryId,
    useMockData,
    itemKey,
    periodicRefresh
) => {
    const {isMobile} = useDeviceDetect()
    const tableName = `${itemName}s`

    const {urlParams} = useUrlParams()
    const {
        [`${itemName}_search`]: search,
        [`${itemName}_page`]: page,
        [`${itemName}_pageSize`]: pageSize,
        [`${itemName}_sort`]: sort,
    } = urlParams

    // const query = paginationType === 'external' && {
    //     page: page || 0,
    //     pageSize: pageSize || INITIAL_PAGE_SIZE,
    //     search,
    //     sort,
    // }
    const {data, refetch} = useGetQuery(queryId)

    useEffect(() => {
        let interval
        if (periodicRefresh > 0) {
            refetch()
            interval = setInterval(() => {
                refetch()
            }, periodicRefresh)
        }
        return interval ? () => clearInterval(interval) : () => {}
    }, [periodicRefresh, refetch])

    useEffect(() => {
        if (paginationType === 'external') {
            refetch()
        }
    }, [urlParams, refetch, paginationType])

    const [errorMessage, setErrorMessage] = useState(null)
    const [doDelete, {error}] = useDeleteMutation()

    useEffect(() => {
        setErrorMessage(error?.data?.message)
    }, [error])

    const {tableKeys, tableData, keyTypes, tableItems, totalItems} =
        getTableData(
            tableName,
            visibleKeys,
            useMockData ? requestsMock : data,
            page,
            pageSize,
            search,
            sort,
            paginationType,
            isMobile
        )

    const [expandedId, setExpandedId] = useState(null)

    const handleExpand = () => (allowExpand ? setExpandedId : null)

    const getExpandedItem = () =>
        tableItems.find((item) => getItemId(item) === expandedId)

    const handleDelete = (itemId, tableRowData) => {
        doDelete({[itemKey]: tableRowData[itemKey]})
    }

    return {
        tableName,
        tableKeys,
        tableData,
        keyTypes,
        tableItems,
        totalItems,
        errorMessage,
        doDelete: handleDelete,
        expandedId,
        handleExpand,
        getExpandedItem,
    }
}

export default useTable
